import { Table } from "antd";
import React, { Component } from "react";
import { AxiosGetSecretApi } from "../../../utils/fetchApi";
import StaticClass from "../../../utils/staticClass";

export default class TableRanhGioi extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPhanKhu: this.props.selectedPhanKhu,
      selectedQuyHoach: this.props.selectedQuyHoach,
      SoQD: this.props.SoQD,
      NamQH: this.props.NamQH,

      dataTable: [],
      pagination: { pageSize: 10, total: 1, current: 1 },
      isLoading: true,
      currentIndex: null,
      query: '',
    };

    this.columns = [
      {
        title: "STT",
        dataIndex: "key",
      },

      {
        title: <div style = {{minWidth: "100px"}}>Tên thửa đất</div>,
        dataIndex: "OQuyHoach",
        with: "80px"
      },

      {
        title: <div style = {{textAlign: "center"}}>Tên phân khu</div>,
        dataIndex: "TenPhanKhu",
      },

      {
        title: "Diện tích (m²)",
        dataIndex: "DienTichFormat",
        render: (cell, row, index) => {
          let DienTichFormat = row.DienTichFormat;
          return StaticClass.formatPrice(DienTichFormat)
        },
      },
    ];
  }

  componentDidMount() {
    this.onSearchClick();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.selectedPhanKhu !== this.props.selectedPhanKhu) {
      this.setState({
        selectedPhanKhu: this.props.selectedPhanKhu,
      });
    }

    if (prevProps.selectedQuyHoach !== this.state.selectedQuyHoach) {
      this.setState({
        selectedQuyHoach: this.props.selectedQuyHoach,
      });
    }

    if (prevState.isUpdate !== this.state.isUpdate) {
      this.onSearchClick('TimKiem');
    }
  }

  onSearchClick = async (e) => {
    this.setState({
      isLoading: true,
    });

    let url = "";
    let query = ''
    if (e === "TimMoi") {
      url = `/api/qh-phan-khu/oquyhoach/search?curPage=1&pageSize=10`;
      this.setState({query})
    } else {
      url = `/api/qh-phan-khu/oquyhoach/search?curPage=${this.state.pagination.current}&pageSize=${this.state.pagination.pageSize}&`;

      if (this.state.selectedPhanKhu) {
        query = query + `OBJECTID=${this.state.selectedPhanKhu}&`;
        url = url + `OBJECTID=${this.state.selectedPhanKhu}&`;
      }

      if (this.state.selectedQuyHoach) {
        let name = encodeURIComponent(this.state.selectedQuyHoach);
        query = query + `TenOQH=${name}&`;
        url = url + `TenOQH=${name}&`;
      }

      if(this.state.NamQH){
        query = query + `NamQH=${this.state.NamQH}&`
        url = url + `NamQH=${this.state.NamQH}&`
      }

      if(this.state.SoQD){
        query = query + `QuyetDinhPhapLy=${this.state.SoQD}`
        url = url + `QuyetDinhPhapLy=${this.state.SoQD}`
      }
    }

    if (e === "pagination") {
      url = `/api/qh-phan-khu/oquyhoach/search?curPage=${this.state.pagination.current}&pageSize=${this.state.pagination.pageSize}&`;
      query = this.state.query;
      url = url + query;
    }

    if (e === "TimKiem") {
      this.setState({query: query})
    }
    let res = await AxiosGetSecretApi(url);
    let dataTable = [];
    if (res && res.dataResult) {
      dataTable = res.dataResult.map((o, index) => {
        return {
          ...o,
          key:
            index +
            1 +
            (this.state.pagination.current - 1) *
              this.state.pagination.pageSize,
        };
      });
      this.setState({
        dataTable: dataTable,
        pagination: res.dataPaginate,
        isLoading: false,
      });
    } else {
      this.setState({
        dataTable: dataTable,
        pagination: this.state.pagination,
        isLoading: false,
      });
    }
  };

  SetStateAsync(state) {
    return new Promise((resolve) => {
      this.setState(state, resolve);
    });
  }

  handleTableChange = async (pagination) => {
    await this.SetStateAsync({ pagination });
    this.onSearchClick('pagination');
  };

  handleSearch() {
    this.SetStateAsync({
      pagination: { pageSize: 10, total: 1, current: 1 },
      selectedPhanKhu: this.props.selectedPhanKhu,
      selectedQuyHoach: this.props.selectedQuyHoach,
      SoQD: this.props.SoQD,
      NamQH: this.props.NamQH,
      isUpdate: !this.state.isUpdate,
    });
  }

  handleReset() {
    this.onSearchClick("TimMoi");
  }

  async getGeoData(id) {
    let res = await AxiosGetSecretApi(
      `https://gis-quyhoach.greenglobal.vn/server/rest/services/SoXayDung/QuyHoachDoThi/MapServer/6/query?f=json&where=1%3D1&returnGeometry=true&spatialRel=esriSpatialRelIntersects&objectIds=${id}&outFields=*&outSR=102100`
    );
    if (
      res &&
      res.features &&
      Array.isArray(res.features) &&
      res.features.length !== 0 &&
      res.features[0].geometry &&
      res.features[0].geometry.rings
    )
      if (this.props.map && this.props.map.current) {
        this.props.map.current.drawRingQuyHoach(res.features[0].geometry.rings);
      }
  }

  render() {
    console.log('query',this.state.query);
    return (
      <div>
        <Table
          columns={this.columns}
          dataSource={this.state.dataTable}
          locale={{ emptyText: "Không có dữ liệu" }}
          bordered
          pagination={{
            ...this.state.pagination,
            showSizeChanger: false,
          }}
          onChange={this.handleTableChange}
          size="small"
          loading={this.state.isLoading}
          rowKey={(record) => record.OBJECTID}
          rowClassName={(record, index) =>
            index +
              (this.state.pagination.current - 1) *
                this.state.pagination.pageSize ===
            this.state.currentIndex
              ? "highlight"
              : "not-highlight"
          }
          onRow={(record, rowIndex) => {
            return {
              onClick: async (event) => {
                this.getGeoData(record.OBJECTID);
                // this.getFile(record.OBJECTID);
                this.setState({
                  currentIndex:
                    rowIndex +
                    (this.state.pagination.current - 1) *
                      this.state.pagination.pageSize,
                });
              }, // click row
            };
          }}
        />
      </div>
    );
  }
}
